import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "editWeightValueModalRef",
  id: "kt_modal_new_group_weight_value",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_group_weight_value_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_group_weight_value_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_group_weight_value_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_group_weight_value_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "modal-footer flex-center" }
const _hoisted_13 = {
  "data-bs-dismiss": "modal",
  id: "kt_modal_new_group_weight_value_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_14 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_group_weight_value_submit",
  class: "btn btn-primary"
}
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_group_weight_value_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.translate('GroupsWeightUpdating')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsValues, (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex flex-column mb-5 fv-row",
                    key: field.id
                  }, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(field.title), 1),
                    _createVNode(_component_Field, {
                      modelValue: field.weight,
                      "onUpdate:modelValue": ($event: any) => ((field.weight) = $event),
                      type: "number",
                      autocomplete: "off",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('weight'),
                      name: `field_${field.id}`
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "name"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, {
                          name: `field_${field.id}`
                        }, null, 8, ["name"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_17
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}